<template>
  <div class="card">
    <div class="card-header">
      <h6>Top Up Point Transaction</h6>
    </div>
    <div class="card-body">
      <table-skeleton v-show="is_loading"/>
      <custom-table v-show="!is_loading" :arr="arr" :total_page="total_page" :url_update="'/order-point?point_id='+point_id" :arr_id="arr_id" :arr_header="arr_header" @on_refresh_start="on_refresh_start" @on_refresh_end="on_refresh_end"/>
    </div>
  </div>
</template>

<script>
import custom_table from '@/layout/table'
import table_skeleton from '@/layout/table_skeleton'

export default {
  components: {
    'custom-table': custom_table,
    'table-skeleton': table_skeleton,
  },
  props: ['data',],
  data(){
    return{
      arr:[],
      arr_header: ['name','publish date'],
      arr_id: ['1'],
      total_page: 1,
      is_loading: true,
      point_id: this.$route.query.id,
    }
  },
  async created(){
    await this.get_data()
    this.is_loading = false
  },
  methods:{
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/order-point?api_type=web-admin&point_id='+this.point_id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr = response_data.arr
          this.arr_header = response_data.arr_header
          this.arr_id = response_data.arr_id
          this.total_page = response_data.total_page
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
